import * as React from 'react';

import { Field } from 'redux-form';

import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';

import type { JobFieldProps } from './job-field';

import { JobField } from './job-field';

import { JobFinalizingHireUpdateSettingReduxFormField } from '../../widgets/redux-form-fields/job-finalizing-hire-update-setting-redux-form-component';

const styles = () =>
  createStyles({
    formField: {
      width: '100%',
    },
  });

interface Props extends JobFieldProps, WithStyles<typeof styles> {}

export const JobFieldFinalizingHireUpdateSetting = withStyles(styles)((props: Props) => {
  const { classes } = props;
  const childrenProps: Partial<Props> = { ...props };
  delete childrenProps.classes;
  return (
    <div className={classes.formField}>
      <JobField
        {...childrenProps}
        editView={
          <Field
            name="finalizingHireStepUpdateSetting"
            component={JobFinalizingHireUpdateSettingReduxFormField}
          />
        }
      />
    </div>
  );
});
